var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.15q.475 0 .788-.325.312-.325.312-.775 0-.475-.312-.788-.313-.312-.788-.312-.475 0-.787.312-.313.313-.313.788 0 .45.313.775.312.325.787.325Zm-1.05-3.975h2.1V6.9h-2.1ZM8.175 21.2 2.8 15.825v-7.65L8.175 2.8h7.65L21.2 8.175v7.65L15.825 21.2Zm.95-2.275h5.75l4.05-4.05v-5.75l-4.05-4.05h-5.75l-4.05 4.05v5.75ZM12 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.dd9ff652369c367d9ba3c909eb70dd51.svg";
export { ForwardRef as ReactComponent };